import { atom } from 'jotai'

import * as s1 from './state.profile'

// read-only derived atom
export const accessAtom = atom(
	// getter
	(get) => {
		const profile = get(s1.profileAtom)
		const access = profile?.role?.access ?? []
		return access
	}
)